module.exports = __webpack_public_path__ + "assets/images/EU-Capital-Lake-BG.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/EU-Capital-Lake-BG.jpg
 ** module id = 30
 ** module chunks = 0
 **/